<template>
  <!-- START : Other information section -->
  <WCForm
    :form="$v.form"
    @update:value="updateOtherInfo"
    @update:valid="$emit('formUpdateValid', $event, 'profileOtherSection')"
    class="w-100"
  >
    <h3>{{ $t('profileOtherSection') }}</h3>
    <!-- Other information - pf1 -->
    <WCFormGroup class="wc-select" :field="$v.form.pf1" v-if="me.pf1 && me.pf1.options">
      <WCLabel for="account-form__pf1">{{ me.pf1.name }}</WCLabel>
      <WCSelect class="bg-light" id="account-form__pf1">
        <option value=""></option>
        <option v-for="option in sortedPf1Options" :key="option.id" :value="option.id">
          {{ option.description }}
        </option>
      </WCSelect>
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Other information - pf2 -->
    <WCFormGroup class="wc-select" :field="$v.form.pf2" v-if="me.pf2 && me.pf2.options">
      <WCLabel for="account-form__pf2">{{ me.pf2.name }}</WCLabel>
      <WCSelect class="bg-light" id="account-form__pf2">
        <option value=""></option>
        <option v-for="option in sortedPf2Options" :key="option.id" :value="option.id">
          {{ option.description }}
        </option>
      </WCSelect>
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Other information - pf3 -->
    <WCFormGroup class="wc-select" :field="$v.form.pf3" v-if="me.pf3 && me.pf3.options">
      <WCLabel for="account-form__pf3">{{ me.pf3.name }}</WCLabel>
      <WCSelect class="bg-light" id="account-form__pf3">
        <option value=""></option>
        <option v-for="option in sortedPf3Options" :key="option.id" :value="option.id">
          {{ option.description }}
        </option>
      </WCSelect>
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Other information - pf4 -->
    <WCFormGroup class="wc-select" :field="$v.form.pf4" v-if="me.pf4 && me.pf4.options">
      <WCLabel for="account-form__pf4">{{ me.pf4.name }}</WCLabel>
      <WCSelect class="bg-light" id="account-form__pf4">
        <option value=""></option>
        <option v-for="option in sortedPf4Options" :key="option.id" :value="option.id">
          {{ option.description }}
        </option>
      </WCSelect>
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Other information - pf5 -->
    <WCFormGroup class="wc-input" :field="$v.form.pf5" v-if="me.pf5">
      <WCLabel for="account-form__pf5">{{ me.pf5.name }}</WCLabel>
      <WCInput class="bg-light form-input" id="account-form__pf5" />
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Other information - pf6 -->
    <WCFormGroup class="wc-input" :field="$v.form.pf6" v-if="me.pf6">
      <WCLabel for="account-form__pf6">{{ me.pf6.name }}</WCLabel>
      <WCInput class="bg-light form-input" id="account-form__pf6" />
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Other information - pf7 -->
    <WCFormGroup class="wc-input" :field="$v.form.pf7" v-if="me.pf7">
      <WCLabel for="account-form__pf7">{{ me.pf7.name }}</WCLabel>
      <WCInput class="bg-light form-input" id="account-form__pf7" />
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Other information - pf8 -->
    <WCFormGroup class="wc-input" :field="$v.form.pf8" v-if="me.pf8">
      <WCLabel for="account-form__pf8">{{ me.pf8.name }}</WCLabel>
      <WCInput class="bg-light form-input" id="account-form__pf8" />
      <WCValidationErrors />
    </WCFormGroup>
    <!-- Other information - receipt -->
    <WCFormGroup>
      <WCCheckbox
        :id="'register-form__receipts'"
        v-model="form.suppressReceipt"
        v-if="me.suppressReceipt"
      >
        {{ $t('goWithPaperless') }}
        <font-awesome-icon class="text-success" icon="leaf" />
        <div class="font-size-xs">
          {{ $t('checkTheBoxForReceipts') }}
        </div>
      </WCCheckbox>
    </WCFormGroup>
  </WCForm>
</template>

<script>
/* eslint-disable func-names */

import { maxLength, required } from 'vuelidate/lib/validators';
import WCFormGroup from '@/modules/forms/components/WCFormGroup/WCFormGroup.vue';
import WCLabel from '@/modules/forms/components/WCLabel/WCLabel.vue';
import WCInput from '@/modules/forms/components/WCInput/WCInput.vue';
import WCForm from '@/modules/forms/components/WCForm/WCForm.vue';
import WCValidationErrors from '@/modules/forms/components/WCValidationErrors/WCValidationErrors.vue';
import WCSelect from '@/modules/forms/components/WCSelect/WCSelect.vue';
import WCCheckbox from '@/modules/forms/components/WCCheckbox/WCCheckbox.vue';
import { ACCOUNT_SETTINGS_OPTIONS } from '@/constants/AppConstants';
import { dynamicSort } from '@/utils';

export default {
  name: 'WCOtherInfoSectionForm',
  components: {
    WCFormGroup,
    WCLabel,
    WCInput,
    WCForm,
    WCValidationErrors,
    WCSelect,
    WCCheckbox,
  },
  emits: ['formUpdateValid', 'formChanged'],
  props: {
    me: {
      type: Object,
    },
  },
  data() {
    return {
      form: {
        pf1: this.me.pf1 && this.me.pf1.value,
        pf2: this.me.pf2 && this.me.pf2.value,
        pf3: this.me.pf3 && this.me.pf3.value,
        pf4: this.me.pf4 && this.me.pf4.value,
        pf5: this.me.pf5 && this.me.pf5.value,
        pf6: this.me.pf6 && this.me.pf6.value,
        pf7: this.me.pf7 && this.me.pf7.value,
        pf8: this.me.pf8 && this.me.pf8.value,
        suppressReceipt: this.me.suppressReceipt && this.me.suppressReceipt.value,
      },
    };
  },
  validations() {
    const powerFieldValidation = {
      required,
      maxLength: maxLength(30),
    };

    return {
      form: {
        pf1:
          this.me.pf1 && this.me.pf1.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? { required }
            : {},
        pf2:
          this.me.pf2 && this.me.pf2.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? { required }
            : {},
        pf3:
          this.me.pf3 && this.me.pf3.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? { required }
            : {},
        pf4:
          this.me.pf4 && this.me.pf4.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? { required }
            : {},
        pf5:
          this.me.pf5 && this.me.pf5.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? powerFieldValidation
            : { maxLength: maxLength(30) },
        pf6:
          this.me.pf6 && this.me.pf6.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? powerFieldValidation
            : { maxLength: maxLength(30) },
        pf7:
          this.me.pf7 && this.me.pf7.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? powerFieldValidation
            : { maxLength: maxLength(30) },
        pf8:
          this.me.pf8 && this.me.pf8.option === ACCOUNT_SETTINGS_OPTIONS.REQUIRED
            ? powerFieldValidation
            : { maxLength: maxLength(30) },
      },
    };
  },
  computed: {
    /**
     * Sort power field 1 options in ascending order
     */
    sortedPf1Options() {
      return this.me && this.me.pf1 && dynamicSort(this.me.pf1.options, 'description');
    },

    /**
     * Sort power field 2 options in ascending order
     */
    sortedPf2Options() {
      return this.me && this.me.pf2 && dynamicSort(this.me.pf2.options, 'description');
    },

    /**
     * Sort power field 3 options in ascending order
     */
    sortedPf3Options() {
      return this.me && this.me.pf3 && dynamicSort(this.me.pf3.options, 'description');
    },

    /**
     * Sort power field 4 options in ascending order
     */
    sortedPf4Options() {
      return this.me && this.me.pf4 && dynamicSort(this.me.pf4.options, 'description');
    },
  },
  mounted() {
    this.formUpdateValidCheck();
  },
  methods: {
    /**
     * Method to emit other info form data if valid
     */
    updateOtherInfo() {
      if (!this.$v.$invalid) {
        this.$emit('formChanged', this.form);
      }
    },
    /**
     * Method to emit validity of form fields
     */
    formUpdateValidCheck() {
      this.$emit('formUpdateValid', !this.$v.$invalid, 'profileOtherSection');
    },
  },
};
</script>
